// extracted by mini-css-extract-plugin
export default {"infoForm":"MandatoryFieldsFrom_infoForm__V+XUt","formGroup":"MandatoryFieldsFrom_formGroup__iLGdt","ageMessage":"MandatoryFieldsFrom_ageMessage__mtrub"};